import { LocalizationString } from '@celito.clients/assets';
import { AttributeTypeEnum, ButtonTypes } from '@celito.clients/enums';
import { ObjectAttributeDefinition } from '@celito.clients/types';
import { Link } from 'react-router';

import { ColumnData, RowItem } from '../../../grid-view-new/src/types';
import { CustomButton } from '../../../shared';
import classes from '../reference-selector.module.css';

export const getPropertyFromAttributeDefinitions = <
  T extends keyof ObjectAttributeDefinition,
>(
  attributeDefinitions: Record<string, ObjectAttributeDefinition> | undefined,
  attributeName: string,
  propertyName: T,
  defaultValue: ObjectAttributeDefinition[T]
): ObjectAttributeDefinition[T] => {
  return attributeDefinitions?.[attributeName]?.[propertyName] ?? defaultValue;
};

export const getDefaultColumnsSelectorGridcolumns = (
  onItemDelete?: (item: RowItem) => void,
  isPreviewTab?: boolean,
  onColumnClick?: ColumnData['onColumnClick'],
  labelText = 'Label',
  referenceUrl = ''
) => {
  const courseGridColumns: ColumnData[] = [
    {
      name: labelText,
      isResizable: true,
      key: 'label',
      maxWidth: 200,
      minWidth: 100,
      fieldName: 'label',
      onColumnClick,
      showSortIconWhenUnsorted: true,
      onRender: (item: RowItem) => (
        <Link
          to={
            referenceUrl
              ? referenceUrl
                  .replace('{name}', item.name)
                  .replace('{version}', item.version)
              : ''
          }
          className={classes.hyperlink}
          target="_blank"
        >
          {item.label}
        </Link>
      ),
    },
    {
      name: 'Title',
      isResizable: true,
      key: 'title',
      maxWidth: 300,
      minWidth: 150,
      fieldName: 'title',
      showTooltip: true,
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      name: 'Status',
      isResizable: true,
      key: 'lifecycleStage',
      maxWidth: 150,
      minWidth: 50,
      fieldName: 'lifecycleStage',
      onColumnClick,
      showSortIconWhenUnsorted: true,
    },
    {
      name: 'Owner',
      isResizable: true,
      key: 'owner',
      maxWidth: 350,
      minWidth: 150,
      fieldName: 'owner.label',
      onColumnClick,
      showSortIconWhenUnsorted: true,
      data: {
        dataType: AttributeTypeEnum.Reference,
        columnNameToBePicked: 'label',
      },
    },
    {
      key: 'actions',
      minWidth: 75,
      maxWidth: 100,
      name: LocalizationString.ACTIONS,
      fieldName: 'actions',
      isResizable: true,
      onRender: (item?: RowItem, index?: number, column?: ColumnData) => (
        <CustomButton
          as="button"
          buttonType={ButtonTypes.Destructive}
          customStyles={classes.delete_btn}
          leftIcon="Delete"
          title="Delete"
          onClick={isPreviewTab ? undefined : () => onItemDelete?.(item!)}
          disabled={isPreviewTab}
        />
      ),
    },
  ];
  return courseGridColumns;
};
